import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-24 bg-truco-surface relative overflow-hidden" data-id="element-216">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl aspect-square bg-truco-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-217" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-219">
          <span className="inline-block px-4 py-1 bg-truco-gold/20 text-truco-gold font-bold tracking-widest rounded-full text-sm mb-6" data-id="element-220">
            LA SOLUCIÓN
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-black text-transparent bg-clip-text bg-gradient-to-r from-truco-gold to-white mb-6" data-id="element-221">
            LA BIBLIA DEL TRUCO ARGENTINO™
          </h2>
          <p className="text-xl md:text-2xl font-heading font-medium text-truco-cream mb-8 text-balance" data-id="element-222">
            El sistema completo de Truco para dominar cualquier mesa, en
            cualquier contexto, contra cualquier rival.
          </p>

          <div className="space-y-6 text-lg text-truco-creamMuted text-left max-w-3xl mx-auto" data-id="element-223">
            <p data-id="element-224">
              Sin improvisar. Sin depender de las cartas que te tocan. Sin
              perder por no saber qué hacer en el momento crítico.
            </p>
            <p data-id="element-225">
              Todo el sistema ya está escrito, organizado y listo para aplicar
              desde la primera partida. Creado por alguien que estudió el Truco
              como lo que es: un juego de personas, no de cartas.
            </p>
            <p data-id="element-226">
              El Método del Ajedrez Criollo nació de años de observar mesas
              argentinas, analizar qué separa al que gana consistentemente del
              que pierde sistemáticamente, y desmenuzar cada decisión hasta
              convertirla en un sistema replicable.
            </p>
          </div>

          <blockquote className="mt-12 p-8 border-l-4 border-truco-gold bg-truco-dark/50 rounded-r-xl italic text-xl text-truco-cream text-left" data-id="element-227">
            "Diseñé este sistema porque el Truco tiene toda la complejidad del
            ajedrez y toda la picardía criolla. Y nadie lo había enseñado así."
          </blockquote>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-gradient-to-br from-truco-dark to-black border border-truco-gold/20 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-228">
          <h3 className="text-sm font-bold tracking-widest text-truco-red mb-2 uppercase" data-id="element-229">
            QUÉ TE LLEVÁS HOY
          </h3>
          <h4 className="text-3xl font-heading font-bold text-truco-gold mb-6" data-id="element-230">
            El Mecanismo Central: El Método del Ajedrez Criollo
          </h4>

          <div className="space-y-4 text-truco-creamMuted" data-id="element-231">
            <p data-id="element-232">
              El error más común del jugador de Truco es creer que el juego se
              gana con buenas cartas.
            </p>
            <p data-id="element-233">
              El Método del Ajedrez Criollo es el sistema que atraviesa los 6
              tomos y cambia para siempre cómo ves el juego:{' '}
              <strong className="text-truco-cream" data-id="element-234">
                el Truco no se juega con cartas, se juega con personas +
                decisiones + presión.
              </strong>
            </p>
            <p data-id="element-235">
              El mismo sistema de lectura que usás en el Tomo 3 para mentir
              mejor es el que usás en el Tomo 5 para detectar cuándo el rival te
              miente a vos. El mismo árbol de decisiones del Tomo 2 para el
              Envido es el que usás en el Tomo 6 para gestionar la presión de un
              torneo.
            </p>
            <p className="text-xl font-heading font-bold text-truco-gold pt-4" data-id="element-236">
              Un solo sistema. En todos los contextos. Para siempre.
            </p>
            <p data-id="element-237">
              Eso no es un detalle. Es la razón por la que este sistema funciona
              cuando el resto no funciona.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}